// @flow
import * as React from 'react'

import { colors } from '@toggl/style'

type Props = {
  fill?: string,
  className?: string,
}

export function IconClose(props: Props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 .943L15.057 0 8 7.057.943 0 0 .943 7.057 8 0 15.057.943 16 8 8.943 15.057 16l.943-.943L8.943 8 16 .943z"
        fill={props.fill || colors.fadedPurple}
        fillOpacity={0.5}
      />
    </svg>
  )
}
